export enum QueryKeys {
  OnesignalLogin = 'onesignalLogin',
}
